import { Shield } from "lucide-react";
import InfoBanner from "../ui/InfoBanner";

export default function ApiKeyConnection({
  apiKey,
  setApiKey,
  environment,
  setEnvironment,
  region,
  setRegion,
  apiEndpoint,
  setApiEndpoint,
  integrationName
}) {
  return (
    <>
      {/* Security Info */}
      <InfoBanner
        icon={Shield}
        title="Secure API Authentication"
        description="Your credentials are encrypted at rest and in transit using AES-256 encryption."
      />

      {/* API Key Field */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          API Key <span className="text-red-500">*</span>
        </label>
        <input
          type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="Enter your API key"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
        />
        <p className="text-xs text-gray-500 mt-1.5">
          Get your API key from the {integrationName} developer portal
        </p>
      </div>

      {/* Environment and Region */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-2">
            Environment
          </label>
          <select
            value={environment}
            onChange={(e) => setEnvironment(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
          >
            <option value="production">Production</option>
            <option value="sandbox">Sandbox</option>
            <option value="staging">Staging</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-2">
            Region
          </label>
          <select
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
          >
            <option value="us-east">US East</option>
            <option value="us-west">US West</option>
            <option value="eu-central">EU Central</option>
            <option value="ap-south">AP South</option>
          </select>
        </div>
      </div>

      {/* API Endpoint (Optional) */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          API Endpoint{" "}
          <span className="text-gray-500 font-normal">(Optional)</span>
        </label>
        <input
          type="text"
          value={apiEndpoint}
          onChange={(e) => setApiEndpoint(e.target.value)}
          placeholder={`https://api.${integrationName.toLowerCase().replace(/\s+/g, "")}.com/v1`}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
        />
        <p className="text-xs text-gray-500 mt-1.5">
          Override the default endpoint if needed
        </p>
      </div>
    </>
  );
}
